import { makeStyles } from "@mui/styles";

export default makeStyles(() => ({
  notfound: {
    maxWidth: "300px",
    paddingBottom: "50px",
    margin: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "50vh"
  }
}));
